// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__eVA3r","statsTable":"Table_statsTable__UdVS-"};